import { render, staticRenderFns } from "./KpisTab.vue?vue&type=template&id=1326684a&scoped=true"
import script from "./KpisTab.vue?vue&type=script&lang=js"
export * from "./KpisTab.vue?vue&type=script&lang=js"
import style0 from "./KpisTab.vue?vue&type=style&index=0&id=1326684a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326684a",
  null
  
)

export default component.exports